module.exports = __webpack_public_path__ + "5352be944edf4c9eb285722b39d94e83.png";